import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f2f7f0e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2f7f0e')) {
      api.createRecord('4f2f7f0e', component.options)
    } else {
      api.reload('4f2f7f0e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f2f7f0e", function () {
      api.rerender('4f2f7f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/guarantee/index.vue"
export default component.exports